import React, { HTMLAttributes } from 'react'

interface CloseIconProps extends HTMLAttributes<HTMLImageElement> {}

const CloseIcon: React.FC<CloseIconProps> = ({ ...props }) => {
  return <img {...props} src="/assets/icons/mobile-menu-close.svg" alt="Mobile menu close icon" />
}

export default CloseIcon
